export const Header = ({ onCta }) => (
  <header
    data-testid="site-header"
    className="sticky top-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
      <a href="#" data-testid="header-logo" className="flex items-center gap-2">
        <img src="/assets/newbraz.png" alt="New Braz logo" className="w-9 h-9 rounded-lg object-contain" />
        <span className="text-xl sm:text-2xl font-black tracking-tighter" style={{ fontFamily: "Outfit, sans-serif" }}>
          New <span className="text-[#FF5A00]">Braz</span>
        </span>
      </a>
      <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-white/60">
        <a href="#beneficios" data-testid="nav-beneficios" className="hover:text-white transition-colors">Benefícios</a>
        <a href="#planos" data-testid="nav-planos" className="hover:text-white transition-colors">Planos</a>
        <a href="#downloads" data-testid="nav-downloads" className="hover:text-white transition-colors">Downloads</a>
        <a href="#dispositivos" data-testid="nav-dispositivos" className="hover:text-white transition-colors">Dispositivos</a>
        <a href="#faq" data-testid="nav-faq" className="hover:text-white transition-colors">FAQ</a>
      </nav>
      <button
        data-testid="cta-header"
        onClick={() => onCta("header")}
        className="bg-[#FF5A00] hover:bg-[#FF7A33] text-white text-sm font-bold rounded-lg px-4 sm:px-6 py-2.5 transition-colors shadow-[0_0_20px_rgba(255,90,0,0.4)]"
      >
        Teste Grátis
      </button>
    </div>
  </header>
);
